// Restore default-open menu-card accordions each time the mobile menu drawer opens.
//
// header-drawer.js `reset()` strips `[open]` from ALL nested <details> when the drawer closes, so
// menu-card accordions marked open_by_default (data-open-default) come back collapsed on the 2nd+
// open. On iOS Safari that collapsed-but-inconsistent state renders as a blank/limbo expanded card
// (the "sub-links disappear on second open" bug). Re-applying `open` when the drawer opens returns
// them to their intended default state and forces a repaint. Loaded unconditionally with the drawer
// (not gated by the search setting), so it always runs.
if (!window.__archiesMenuAccordionRestore) {
  window.__archiesMenuAccordionRestore = true;

  const wire = () => {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return false;

    const restore = () => {
      if (!drawer.classList.contains('menu-open')) return;
      drawer
        .querySelectorAll('.menu-card-ext__details[data-open-default]:not([open])')
        .forEach((details) => {
          details.open = true;
        });
    };

    new MutationObserver(restore).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    restore();
    return true;
  };

  if (!wire()) {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  }
}
